/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/mediaPreparationTable";
import { Form } from "react-bootstrap";

export const getProductMasterColumns = (
    t: any,
    onStatusChange: (id: string, status: string) => void,
    canEdit: boolean
  ): Column[] => [

  {
    header: t("mediaPowderProductMaster.tableColumns.sl_no"),
    key: "slno",
  },
  {
    header: t("mediaPowderProductMaster.tableColumns.media_name"),
    key: "media_name",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.name}
        </span>
      </td>
    ),
  },
  {
    header: t("mediaPowderProductMaster.tableColumns.media_type"),
    key: "media_type",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.type}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowderProductMaster.tableColumns.manufacturer"),
    key: "manufacturer",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.mf}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowderProductMaster.tableColumns.catalogNumber"),
    key: "catalog_number",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.cat}
        </span>
      </td>
    ),
  },

  {
    header: t("mediaPowderProductMaster.tableColumns.initialPh"),
    key: "initialPh",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.initialPh}
        </span>
      </td>
    ),
  },
  {
    header: t("mediaPowderProductMaster.tableColumns.finalPh"),
    key: "finalPh",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.finalPh}
        </span>
      </td>
    ),
  },
  {
    header: t("mediaPowderProductMaster.tableColumns.shelfLife"),
    key: "shelfLife",
    render: (row) => (
      <td className="px-6 py-2">
        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.shelfLife}
        </span>
      </td>
    ),
  },
  {
  header: t("mediaPowderProductMaster.tableColumns.status"),
  key: "status",
  render: (row: any) => (
    <td className="px-6 py-2">
      <div className="flex items-center gap-2">
        <Form.Check
          type="switch"
          id={`status-${row.id}`}
          className="custom-switch-class"
          checked={row.status?.toLowerCase() === "active"}
          disabled={!canEdit}
          onChange={() => {
            if (canEdit) {
              onStatusChange(row.id, row.status);
            }
          }}
        />

        <span className="text-[14px] font-medium text-slate-700 whitespace-nowrap">
          {row.status?.toLowerCase() === "active"
            ? "Active"
            : "Inactive"}
        </span>
      </div>
    </td>
  ),
},
];